import { render, staticRenderFns } from "./BcFlat.vue?vue&type=template&id=4593ea8e"
import script from "./BcFlat.vue?vue&type=script&lang=js"
export * from "./BcFlat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports